// src/App.js
import React, { useState, useCallback, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import SoftwareDevelopment from './pages/Services/SoftwareDevelopment';
import MobileDevelopment from './pages/Services/MobileDevelopment';
import ECommerceDevelopment from './pages/Services/ECommerceDevelopment';
import WebsiteDevelopment from './pages/Services/WebsiteDevelopment';
import DigitalMarketing from './pages/Services/DigitalMarketing';
import Branding from './pages/Services/Branding';
import ThreeDAnimation from './pages/Services/ThreeDAnimation';
import EducationalConsultancy from './pages/Services/EducationalConsultancy';
import Expertise from './pages/Expertise/Expertise';
import Portfolio from './pages/Portfolio/Portfolio';
import Contact from './pages/Contact/Contact';
import './styles/global.css';
import WhatsAppFloat from './components/WhatsAppFloat';
import '@fortawesome/fontawesome-free/css/all.min.css';
import ScrollToTop from './components/ScrollToTop';
import Splash from './splash';
import useAnalytics from './useAnalytics';



const InnerApp = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showSplash, setShowSplash] = useState(false);
  const [splashKey, setSplashKey] = useState(0);

  // Set initial splash state based on initial pathname (runs once on app mount/hard reload)
  // useEffect(() => {
  //   if (location.pathname === '/') {
  //     setShowSplash(true);
  //   } else {
  //     setShowSplash(false);
  //   }
  // }, []);
   // Empty dependency array: runs only once on mount

  // Function to restart splash screen
  const restartSplash = useCallback(() => {
    // Scroll to top immediately before showing splash
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
   
    // Force a reflow to ensure scroll happens
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
   
    setShowSplash(true);
    setSplashKey(prevKey => prevKey + 1);
    navigate('/', { replace: true });
  }, [navigate]);

  // Tracks pageviews inside Router safely
  const AnalyticsTracker = () => {
    useAnalytics();
    return null;
  };

  // const handleSplashComplete = useCallback(() => {
  //   setShowSplash(false);
  //   requestAnimationFrame(() => {
  //     window.scrollTo({
  //       top: 0,
  //       left: 0,
  //       behavior: 'instant'
  //     });
  //     document.documentElement.scrollTop = 0;
  //     document.body.scrollTop = 0;
  //   });
  // }, []);

  // if (showSplash) {
  //   return <Splash key={splashKey} onComplete={handleSplashComplete} />;
  // }

  return (
    <>
      <ScrollToTop />
      {/* ✅ Analytics hook is now inside Router */}
      <AnalyticsTracker />
      <div className="App">
        <Navbar onLogoClick={restartSplash} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/softwaredevelopment" element={<SoftwareDevelopment />} />
          <Route path="/mobiledevelopment" element={<MobileDevelopment />} />
          <Route path="/ecommercedevelopment" element={<ECommerceDevelopment />} />
          <Route path="/websitedevelopment" element={<WebsiteDevelopment />} />
          <Route path="/digitalmarketing" element={<DigitalMarketing />} />
          <Route path="/branding" element={<Branding />} />
          <Route path="/3danimations" element={<ThreeDAnimation />} />
          <Route path="/educationalconsultancy" element={<EducationalConsultancy />} />
          <Route path="/expertise" element={<Expertise />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <WhatsAppFloat />
        <Footer onLogoClick={restartSplash} />
      </div>
    </>
  );
};

function App() {
  return (
    <Router>
      <InnerApp />
    </Router>
  );
}

export default App;